export default __webpack_public_path__ + "static/media/20-8.2f2f5094.mp3";